<form #minimalForm="ngForm" (ngSubmit)="onSubmit()">

  <div>
    <label>
      <input type="radio" name="context" value="siteUid" [(ngModel)]="context"> Site UID
    </label>
    <label>
      <input type="radio" name="context" value="dealerContext" [(ngModel)]="context"> Dealer Context
    </label>
  </div>

  <div>
    <label for="value">Value:</label>
    <input type="text" id="value" name="value" [(ngModel)]="value">
  </div>

  <div>
    <label for="environment">Environment:</label>
    <select id="environment" name="environment" [(ngModel)]="environment">
      <option value="CD">CD</option>
      <option value="DEV">DEV</option>
      <option value="QA">QA</option>
      <option value="PROD">PROD</option>
      <option value="RESTORE">RESTORE</option>
      <option value="TRAINING">TRAINING</option>
    </select>
  </div>

  <button type="submit" [disabled]="!minimalForm.valid">Submit</button>

</form>


@if (data) {
  <pre>
{{JSON.stringify(data, null, 2)}}
  </pre>
}
